import AffiliationSearchField from './AffiliationSearchField';

export default AffiliationSearchField;
